var _line, _path, _circle, _line2, _circle2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuepoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 3,
    y2: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12h2l1.5-5 2.5 11 2.5-9 2 6 1.5-3h6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 1.2,
    fill: "currentColor",
    stroke: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 5,
    x2: 8,
    y2: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 4,
    r: 1.2,
    fill: "currentColor",
    stroke: "none"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 15,
    y2: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuepoints);
export default __webpack_public_path__ + "static/media/cuepoints.dd07da3b03421fcfabf224d3438bffea.svg";
export { ForwardRef as ReactComponent };